<template xmlns="http://www.w3.org/1999/html">
    <div class="app">
        <scroll @refresh="refresh" class="report-bottom report-detail">
            <div class="report-detail-title icon-msg-h">
                <span class="icon report-item-img"></span>
                <div class="f-largest">{{queryParam.labItem}}</div>
            </div>

            <section class="report-detail-qrcode thick" v-show="qrcodeEnable">
                <p>打印报告二维码</p>
                <!--<div class="bar-code-bg">-->
                <!--<svg id="barcode"></svg>-->
                <!--</div>-->
                <!--<o2o-helper :type="2"></o2o-helper>-->
                <section class="thick" style="margin-top: 40px">
                    <!--<div class="row" style="padding: 1.25rem 0 1.5rem 1.25rem"></div>-->
                    <qrcode :size="171" class="qrcode" :cls="qrCls" :value="qrText"></qrcode>
                    <o2o-helper :type="0"></o2o-helper>
                </section>
            </section>
            <ul class="list">
                <li class="thick-item">
                    <span>{{labDetail.hospitalName}}</span></li>
                <!--<li class="thick-item">-->
                <!--<span>获取不到科室</span></li>-->
                <!--<li class="thick-item">-->
                <!--<span class="left-text">门诊医生</span> <span>获取不到医生</span></li>-->
                <li class="thick-item">
                    <span class="left-text">卡号</span> <span>{{labDetail.cardNo}}</span></li>
                <li class="thick-item">
                    <span class="left-text">报告单号</span> <span>{{queryParam.labId}}</span></li>
                <li class="thick-item">
                    <span class="left-text">出单时间</span> <span>{{queryParam.labTime}}</span></li>
            </ul>
            <section class="report-wrapper">
                <section v-for="(labItem, index) in labItems" :key="index" style="padding: 0 20px 5px;background: #fff;margin-bottom: 5px">
                    <div class="item-detail-title f-strong" @click="showDetail(labItem)">
                        <label>{{labItem.labItem}}</label>
                        <span v-show="!labItem.showDetailInfo" class="arr-gray-down"></span>
                        <span v-show="labItem.showDetailInfo" class="arr-gray-up"></span>
                    </div>
                    <div v-if="labItem.data.length>0" v-show="labItem.showDetailInfo">
                        <div v-for="item in labItem.data">
                            <div class="report-table-title">
                                <div class="pull-left">
                                    <label>{{item.itemName}}</label>
                                </div>
                            </div>
                            <div class="report-table-container">
                                <table class="report-table">
                                    <tr class="f-minor">
                                        <td>项目单位</td>
                                        <td>结果</td>
                                        <td>参考范围</td>
                                    </tr>
                                    <tr>
                                        <td class="f-normal">{{item.itemUnit}}</td>
                                        <td class="f-normal">{{item.itemResult}}
                                            <div v-if="item.refRangeMax !== '' " style="display: inline;">
                                                <span v-if=" ~~(item.itemResult.split(' ')[0].replace(/[^0-9,.]/ig,'')) >  ~~(item.refRangeMax)"><div
                                                        class="up-frame"></div></span>
                                                <span v-if=" ~~(item.itemResult.split(' ')[0].replace(/[^0-9,.]/ig,'')) <  ~~(item.refRangeMin)"><div
                                                        class="down-frame"></div></span>
                                            </div>
                                        </td>
                                        <td class="f-normal">{{item.refRange}}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </section>
            </section>
        </scroll>
        <footer>
            <div class="max-min f-identify" style="float: right">
                <div class="up-frame"></div>
                表示偏高
            </div>
            <div class="max-min f-identify">
                <div class="down-frame"></div>
                表示偏低
            </div>
        </footer>
    </div>
</template>
<script>
    import queryFuncDetail from 'queryFunDetail.service'
    import O2oHelper from 'O2OHelper'
    import Qrcode from 'v-qrcode'

    export default {
        components: {
            O2oHelper,
            Qrcode
        },
        data() {
            return {
                labDetail: {},
                queryParam: {},
                show: false,
                qrCls: 'qrcode',
                qrText: '',
                labItems: [],
                qrcodeEnable: false
            }
        },
        mounted() {
            this.refresh();
            let selectedHospital = localStorage.selectedHospital;
            if (selectedHospital) {
                if (JSON.parse(selectedHospital).hospitalId === this.constant.HOSPITAL_ID.FYBJ) {
                    this.qrcodeEnable = true;
                }
            }
        },
        methods: {
            refresh() {

                this.messagePush();
                queryFuncDetail.getLabDetail(this.queryParam).then((res) => {
                    if (res.resultCode === this.constant.RESULT_SUCCESS) {
                        const data = res.data

                        this.qrText = data.qrCode;
                        if (data.items.length > 0) {
                            for (var i = 0; i < data.items.length; i++) {
                                data.items[i].showDetailInfo = false;
                            }
                            data.items[0].showDetailInfo = true;
                            this.labItems = data.items;
                        }
                        this.labDetail = data
                    } else {
                        this.$utils.alert(res.resultMsg)
                    }
                })
            },
            showHelp() {
                this.show = !this.show;
            },
            showDetail(item) {
                item.showDetailInfo = !item.showDetailInfo;
            },
            messagePush() {
                var query = this.$router.currentRoute.query;
                //区分消息推送和正常页面跳转
                if (query.labId) {
                    //消息推送情况下，将需要的参数取下来保存至this.param.queryParam
                    const geturlParam = {
                        "labItem": query.labItem,
                        "cardType": query.cardType,
                        "cardNo": query.cardNo,
                        "labId": query.labId,
                        "labTime": query.labTime,
                        "startDate": query.endDate,
                        "endDate": query.endDate
                    };
                    this.queryParam = geturlParam;

                    //设置医院消息头和localStorage
                    const hospital = {
                        "hospitalId": query.hospitalId,
                        "hospitalIndex": query.hospitalIndex,
                        "hospitalName": query.hospitalName,
                        "hospitalType": query.hospitalType
                    };
                    localStorage.selectedHospital = JSON.stringify(hospital);
                    http.headers.common['hospitalId'] = hospital.hospitalId;
                } else {
                    this.queryParam = this.param.queryParam;
                }
            }
        },
        computed: {
            param() {
                return this.$store.state.paramModule.param.myLab;
            }
        }
    }
</script>
<style lang="scss">
    @import '../../../static/sass/_variable.scss';

    .max-min {
        width: 50%;
        height: 40px;
        text-align: center;
        display: inline-block;
        line-height: 40px;
    }

    .up-frame {
        width: 8px;
        height: 10px;
        margin-right: 5px;
        background-image: url(../../../static/img/biaoge-red.png);
        background-size: cover;
        background-repeat: no-repeat;
        display: inline-block;
    }

    .down-frame {
        width: 8px;
        height: 10px;
        margin-right: 5px;
        background-image: url(../../../static/img/biaoge-green.png);
        background-size: cover;
        background-repeat: no-repeat;
        display: inline-block;
    }

    .report-bottom {
        margin-bottom: 40px;
    }

    .report-table-title {
        height: 1.5rem;
        line-height: 1.5rem;
    }
</style>



// WEBPACK FOOTER //
// LabDetail.vue?365b05b6